class GaHelper {
    ga() {
        if ('ga' in window) {
            let gaList = ga.getAll();
            if (gaList.length > 0) {
                let gaName = gaList[0].get('name');
                let args = [...arguments];
                if (gaName) {
                    args[0] = `${gaName}.${args[0]}`
                }
                window.ga.apply(window, args)
            } else {
                console.error('ga.getAll() return 0 items');
            }
        } else {
            console.error('No global ga function found');
        }
    }
}

let instance = new GaHelper();

export default instance;



// WEBPACK FOOTER //
// ./app/general/js/ga-helper.js